export enum MutationList {
    SET_NAVIGATION_POINTS = 'SET_NAVIGATION_POINTS',
    SET_INITIALIZATION_TO_TRUE = 'SET_INITIALIZATION_TO_TRUE',
    SET_CURRENT_INDEX ='SET_CURRENT_INDEX',
    SET_PREVIOUS_ROUTE = 'SET_PREVIOUS_ROUTE',
    SET_TARGET_ROUTE = 'SET_TARGET_ROUTE',
    FORWARD_ARROW_STATE = 'FORWARD_ARROW_STATE',
    BACKWARD_ARROW_STATE = 'BACKWARD_ARROW_STATE'
}